<template>
  <div class="home">
    <HeaderPayment/>
    <section class="success">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h1>Congratulation!</h1>
          <h4>Your Top-Up request to the mobile number <span>{{mobile}}</span> of amount <span>{{amount}} BDT</span> is Successful.</h4>
        </div>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
import HeaderPayment from "../components/HeaderPayment";
import Footer from "../components/Footer";
export default {
  name: "TopupSuccess",
  components: {HeaderPayment,Footer},
  data() {
    return {
      mobile: localStorage.getItem('mobile'),
      amount: localStorage.getItem('amount')
    }
  }
}
</script>

<style scoped>
.success {
  margin-top: 40px;
}
.section-title h1 {
  margin-top: 50px;
  color: #8f2d56;
  font-weight: bold;
}
.section-title h4 {
  margin-top: 20px;
  color: #8f2d56;
  font-weight: bold;
  font-size: 25px;
}
.section-title span {
  color: #004a59;
}
</style>